module.exports = __webpack_public_path__ + "img/weapons_team.ca2a84b9.webp";